import React from 'react';
import './Header.css';
import logo from './logo.png';

const Header = ({ toggleNav }) => {
  return (
    <header className="app-header">
      <div className="hamburger" onClick={toggleNav}>
        &#9776;
      </div>
      <div className="logo-container">
        <img src={logo} alt="Maestro Logo" className="logo" />
        <h1 className="app-title">MAESTRO</h1>
      </div>
    </header>
  );
};

export default Header;